import Route from '@ember/routing/route';

export default class RegisterRoute extends Route {}
